"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleError = exports.UnknowError = exports.NetworkError = exports.ServerError = void 0;
const lodash_1 = __importDefault(require("lodash"));
class ServerError extends Error {
    constructor(code, message, internalCode, detail) {
        super(message);
        this.name = 'BP_ADMIN_CONSOLE_CLIENT_SERVER_ERROR';
        this.code = code;
        this.detail = detail;
        this.internalCode = internalCode;
    }
}
exports.ServerError = ServerError;
/**
 * Network error class. This error is returned when the call is interrupted by network
 */
class NetworkError extends Error {
    constructor(message, error) {
        super(message);
        this.name = 'BP_ADMIN_CONSOLE_CLIENT_NETWORK_ERROR';
        this.code = 500;
        this.detail = error.stack ? error.stack : error;
    }
}
exports.NetworkError = NetworkError;
/**
 * Unknown Error is returned for error not know reason
 */
class UnknowError extends Error {
    constructor(message, internalCode, detail) {
        super(message);
        this.name = 'BP_ADMIN_CONSOLE_CLIENT_UNKNOW_ERROR';
        this.code = 500;
        this.detail = detail;
        this.internalCode = internalCode;
    }
}
exports.UnknowError = UnknowError;
function handleError(error) {
    if (error.name === 'BP_ADMIN_CONSOLE_CLIENT_SERVER_ERROR') {
        throw new ServerError(error === null || error === void 0 ? void 0 : error.code, error === null || error === void 0 ? void 0 : error.message);
    }
    if (error.isAxiosError) {
        if (error.response) {
            const statusCode = lodash_1.default.get(error, 'response.status', 400);
            const message = lodash_1.default.get(error, 'response.data.error.message', null) ||
                lodash_1.default.get(error, 'response.data.message', null) ||
                lodash_1.default.get(error, 'response.statusText', null);
            const internalCode = lodash_1.default.get(error, 'response.data.error.internalCode', statusCode);
            const detail = lodash_1.default.get(error, 'response.data.error.detail', 'No detail');
            throw new ServerError(statusCode, message, internalCode, detail);
        }
        else if (error.request) {
            throw new NetworkError('The request was made but no response was received', error.request);
        }
        else {
            throw new NetworkError('Something happened in setting up the request that triggered an Error', error);
        }
    }
    else {
        throw new UnknowError(error.message, 500, error.stack);
    }
}
exports.handleError = handleError;
